import React from "react";
import { Editor } from '@tinymce/tinymce-react';

function EditorDescLungaTINYMCE({
    nuovaDesc,
    initialValue,
    value,
    handleChangeEditor
}) {

    if (nuovaDesc) {
        return <Editor
        apiKey="gfyxk5n5gi8ujd8b35w2oww85uqpmiqit7glziw7m5rfpjrp"
        initialValue={initialValue}
        value={value}
        onEditorChange={handleChangeEditor}
        key="editorDescLunga"
        init={
            {
                height: 800,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image',
                    'charmap print preview anchor help',
                    'searchreplace visualblocks code',
                    'insertdatetime media table paste wordcount'
                ],
                toolbar:
                    'undo redo | bold underline italic |  alignleft bullist | removeformat'

            }}
    />
    } else {
        return <Editor
        apiKey="gfyxk5n5gi8ujd8b35w2oww85uqpmiqit7glziw7m5rfpjrp"
        value={value}
        onEditorChange={handleChangeEditor}
        key="editorDescLunga"
        init={
            {
                height: 800,
                menubar: false,
                plugins: [
                    'advlist autolink lists link image',
                    'charmap print preview anchor help',
                    'searchreplace visualblocks code',
                    'insertdatetime media table paste wordcount'
                ],
                toolbar:
                    'undo redo | bold underline italic |  alignleft bullist | removeformat'
            }}
    />
    }
}

export default EditorDescLungaTINYMCE;



